import FormWrapper from '@/components/form/form-wrapper/form-wrapper';
import { FieldType, SignInForm } from '@/components/sign-in-form/sign-in-form';
import VerificationForm from '@/components/verification-form/verification-form';
import { useAuth } from '@/hooks/use-auth/use-auth';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { Flex } from 'antd';
import styles from './sign-in.module.scss';
import { HttpStatusCode } from 'axios';
import arrowSvg from '@/assets/images/arrow.svg?url';

export function SignIn() {
  const { authUser, isAuthorizing, authError } = useAuth();
  const [userEmail, setUserEmail] = useState('');

  const navigate = useNavigate();
  const { state } = useLocation();

  const from = state?.from || '/';

  const onFinish = async ({ email, password }: FieldType) => {
    const response = await authUser({ email, password });

    if (response?.user.mfa_required) {
      setUserEmail(email);
      navigate('/sign-in', {
        state: {
          verification: true,
          mfaToken: response.user.mfa_token,
          availableMethods: response.user.available_methods,
          userEmail: email,
          from,
        },
      });
    } else {
      navigate(from, { replace: true });
    }
  };

  return (
    <Flex vertical align="center">
      <FormWrapper>
        {!state?.verification ? (
          <SignInForm
            onSubmit={onFinish}
            errors={
              authError?.response?.status === HttpStatusCode.Unauthorized
                ? ''
                : authError?.response?.data.errors
            }
            isLoading={isAuthorizing}
          />
        ) : (
          <VerificationForm
            userEmail={state?.userEmail || userEmail}
            mfaToken={state?.mfaToken}
            availableMethods={state?.availableMethods}
          />
        )}
      </FormWrapper>
      <img className={styles.arrow} src={arrowSvg} />
    </Flex>
  );
}
